export function formatEuro(euros: number) {
    return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
    })
        .format(Math.round(euros))
        .replace(',00', ',-');
}

export function formatEuroCompact(euros: number) {
    return '€ ' + Math.round(euros / 1000) + 'k';
}
